/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./PBI.Tile.vue?vue&type=template&id=741373e3"
import script from "./PBI.Tile.vue?vue&type=script&lang=js"
export * from "./PBI.Tile.vue?vue&type=script&lang=js"
import style0 from "./PBI.Tile.vue?vue&type=style&index=0&id=741373e3&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports